import { useNavigate } from "react-router-dom";
import SalaryListView from "./SalaryListView";

const SalaryListWrapper = () => {
  const navigate = useNavigate();

  return <SalaryListView navigate={navigate} />;
};
export default SalaryListWrapper;
